export const ORDER_MODAL_TYPES = {
    addSigner: 'add-signer',
    listSigners: 'list-signers',
    selectAutographItem: 'select-autograph-item',
    addAutographCard: 'add-autograph-card',
    selectAutographService: 'select-autograph-service',
    selectStickerPlacement: 'select-sticker-placement',
    selectGrading: 'select-grading',
    setCardOptions: 'set-card-options'
}